import { useEffect, useState } from "react";
import ViewerEvent from "../../api/core/ViewerEvent";

export default function useMosaicEvent(
  events: ViewerEvent | ViewerEvent[],
  callback: (event: any) => void
) {
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const eventArray = Array.isArray(events) ? events : [events];

    function callbackToRun(event) {
      callback(event.detail);
    }

    if (!window.Viewer) {
      const timeoutId = window.setTimeout(() => {
        setRetry((oldRetry) => oldRetry + 1);
      }, 50);
      return () => clearTimeout(timeoutId);
    }

    eventArray.forEach((evt) => {
      // Bind directly to viewer for performance reasons
      window.Viewer.listen(evt, callbackToRun);
    });

    return () => {
      eventArray.forEach((evt) => {
        window.Viewer.mute(evt, callbackToRun);
      });
    };
  }, [callback, events, retry]);
}
